<template>
    <div id="automatic-replies-card">
        <h2>{{ $t("settings.channels.Automatic replies") }}</h2>

        <b-form-group
            id="fieldset-doubleReply"
            :description="$t('settings.channels.double-reply.description')"
            :label="$t('settings.channels.double-reply.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="doubleReplyActive"
        >
            <b-form-checkbox
                v-model="getSettingByName('doubleReplyActive').value"
                inline
                name="doubleReplyActive"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>

        <b-form-group
            id="fieldset-autoReplyEnabled"
            :description="$t('settings.channels.welcome.enable.description')"
            :label="$t('settings.channels.welcome.enable.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="autoReplyEnabled"
        >
            <b-form-checkbox
                v-model="getSettingByName('autoReplyActive').value"
                inline
                name="autoReplyEnabled"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>

        <b-form-group
            id="fieldset-autoReplyBusinessInitiatedCheck"
            :description="$t('settings.channels.welcome.not-on-business-initiated.description')"
            :label="$t('settings.channels.welcome.not-on-business-initiated.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="autoReplyBusinessInitiatedCheck"
        >
            <b-form-checkbox
                v-model="getSettingByName('autoReplyBusinessInitiatedCheck', '0').value"
                inline
                name="autoReplyBusinessInitiatedCheck"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>

        <b-form-group
            id="fieldset-autoReplyMessage"
            :description="$t('settings.channels.welcome.message.description')"
            :label="$t('settings.channels.welcome.message.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="autoReplyMessage"
        >
            <b-form-textarea
                id="autoReplyMessage"
                v-model="getSettingByName('autoReplyMessage').value"
                name="autoReplyMessage"
                rows="2"
            />
            <AutoReplyButtonGroup
                :id="'autoReply'"
                :allow-files="channelData.platform.toLowerCase() !== 'sms'"
                :selected-filename="attachmentData.autoReplyAsset"
                :uploading-file="attachmentsAreUploading.autoReplyAsset"
                name="autoReplyMessageButtonGroup"
                @select-emoji="selectEmoji($event, 'autoReplyMessage')"
                @selected-variable="addVariable($event, 'autoReplyMessage')"
                @set-file="setAttachment($event, 'autoReplyAsset')"
                @remove-file="removeAttachment('autoReplyAsset')"
            />
        </b-form-group>

        <div v-if="channelData.platform !== PlatformType.EMAIL">
            <br />
            <br />

            <b-form-group
                id="fieldset-custom-statement-frequency"
                :description="$t('settings.channels.custom-statement.frequency.description')"
                :label="$t('settings.channels.custom-statement.frequency.label')"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="customStatementFrequency"
            >
                <b-form-select
                    v-model="getSettingByName('customStatementFrequency', 'never').value"
                    :options="customStatementFrequencies"
                    name="customStatementFrequency"
                />
            </b-form-group>

            <b-form-group
                id="fieldset-custom-statement"
                :description="$t('settings.channels.custom-statement.message.description')"
                :label="$t('settings.channels.custom-statement.message.label')"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="customStatement"
            >
                <b-form-textarea
                    id="custom-statement-textarea"
                    v-model="getSettingByName('customStatement').value"
                    name="customStatement"
                    rows="2"
                />
                <AutoReplyButtonGroup
                    id="custom-statement-buttons"
                    :allow-files="channelData.platform.toLowerCase() !== 'sms'"
                    :selected-filename="attachmentData.customStatementAsset"
                    :uploading-file="attachmentsAreUploading.customStatementAsset"
                    name="autoReplyMessageButtonGroup"
                    @select-emoji="selectEmoji($event, 'customStatement')"
                    @selected-variable="addVariable($event, 'customStatement')"
                    @set-file="setAttachment($event, 'customStatementAsset')"
                    @remove-file="removeAttachment('customStatementAsset')"
                />
            </b-form-group>
        </div>

        <br />
        <br />

        <b-form-group
            id="fieldset-outOfOfficeWeekdaysEnabled"
            :description="$t('settings.channels.out-of-office.weekdays.enable.description')"
            :label="$t('settings.channels.out-of-office.weekdays.enable.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="outOfOfficeWeekdaysEnabled"
        >
            <b-form-checkbox
                v-model="getSettingByName('outOfOfficeActive').value"
                inline
                name="outOfOfficeWeekdaysEnabled"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>

        <b-form-group
            id="fieldset-outOfOfficeBusinessInitiatedCheck"
            :description="$t('settings.channels.out-of-office.weekdays.not-on-business-initiated.description')"
            :label="$t('settings.channels.out-of-office.weekdays.not-on-business-initiated.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="outOfOfficeBusinessInitiatedCheck"
        >
            <b-form-checkbox
                v-model="getSettingByName('outOfOfficeBusinessInitiatedCheck', '0').value"
                inline
                name="outOfOfficeBusinessInitiatedCheck"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>

        <b-form-group
            id="fieldset-outOfOfficeWeekdaysMessage"
            :description="$t('settings.channels.out-of-office.weekdays.message.description')"
            :label="$t('settings.channels.out-of-office.weekdays.message.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="outOfOfficeWeekdaysMessage"
        >
            <b-form-textarea
                id="outOfOfficeMessage"
                v-model="getSettingByName('outOfOfficeMessage').value"
                name="outOfOfficeMessage"
                rows="2"
            />
            <AutoReplyButtonGroup
                :id="'outOfOffice'"
                :allow-files="channelData.platform.toLowerCase() !== 'sms'"
                :selected-filename="attachmentData.outOfOfficeAsset"
                :uploading-file="attachmentsAreUploading.outOfOfficeAsset"
                name="outOfOfficeWeekdaysMessageButtonGroup"
                @select-emoji="selectEmoji($event, 'outOfOfficeMessage')"
                @selected-variable="addVariable($event, 'outOfOfficeMessage')"
                @set-file="setAttachment($event, 'outOfOfficeAsset')"
                @remove-file="removeAttachment('outOfOfficeAsset')"
            />
        </b-form-group>

        <br />
        <br />

        <b-form-group
            id="fieldset-outOfOfficeWeekendsEnabled"
            :description="$t('settings.channels.out-of-office.weekends.enable.description')"
            :label="$t('settings.channels.out-of-office.weekends.enable.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="outOfOfficeWeekendsEnabled"
        >
            <b-form-checkbox
                v-model="getSettingByName('outOfOfficeWeekendActive').value"
                inline
                name="outOfOfficeWeekendsEnabled"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>

        <b-form-group
            id="fieldset-outOfOfficeWeekendBusinessInitiatedCheck"
            :description="$t('settings.channels.out-of-office.weekends.not-on-business-initiated.description')"
            :label="$t('settings.channels.out-of-office.weekends.not-on-business-initiated.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="outOfOfficeWeekendBusinessInitiatedCheck"
        >
            <b-form-checkbox
                v-model="getSettingByName('outOfOfficeWeekendBusinessInitiatedCheck', '0').value"
                inline
                name="outOfOfficeWeekendBusinessInitiatedCheck"
                switch
                unchecked-value="0"
                value="1"
            />
        </b-form-group>

        <b-form-group
            id="fieldset-outOfOfficeWeekendMessage"
            :description="$t('settings.channels.out-of-office.weekends.message.description')"
            :label="$t('settings.channels.out-of-office.weekends.message.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="outOfOfficeWeekendMessage"
        >
            <b-form-textarea
                id="outOfOfficeWeekendMessage"
                v-model="getSettingByName('outOfOfficeWeekendMessage').value"
                name="outOfOfficeWeekendMessage"
                rows="2"
            />
            <AutoReplyButtonGroup
                :id="'outOfOfficeWeekends'"
                :allow-files="channelData.platform.toLowerCase() !== 'sms'"
                :selected-filename="attachmentData.outOfOfficeWeekendAsset"
                :uploading-file="attachmentsAreUploading.outOfOfficeWeekendAsset"
                name="outOfOfficeWeekendsMessageButtonGroup"
                @select-emoji="selectEmoji($event, 'outOfOfficeWeekendMessage')"
                @selected-variable="addVariable($event, 'outOfOfficeWeekendMessage')"
                @set-file="setAttachment($event, 'outOfOfficeWeekendAsset')"
                @remove-file="removeAttachment('outOfOfficeWeekendAsset')"
            />
        </b-form-group>

        <hr />
    </div>
</template>

<script>
import { BButton, BButtonGroup, BCard, BFormCheckbox, BFormGroup, BFormSelect, BFormTextarea } from "bootstrap-vue";
import { VEmojiPicker } from "v-emoji-picker";
import { addDataToInput } from "@/utils/input.ts";
import { resolveFilesizeLimit } from "@/utils/channels";
import AutoReplyButtonGroup from "./autoReplyButtonGroup";
import useChannelSettings from "../useChannelSettings";
import useFileUploads from "@/composables/useFileUploads";
import ToastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import axios from "@/libs/axios";
import i18n from "@/libs/i18n";
import { PlatformType } from "@/types/platform.type";
import { ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";

export default {
    components: {
        BCard,
        BFormGroup,
        BFormTextarea,
        BFormCheckbox,
        BButton,
        VEmojiPicker,
        BButtonGroup,
        BFormSelect,
        AutoReplyButtonGroup,
    },
    props: {
        channelData: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { getSettingByName } = useChannelSettings(props.channelData);
        const { uploadFile } = useFileUploads();
        const toast = useToast();

        const customStatementFrequencies = [
            {
                value: "never",
                text: i18n.t("settings.channels.auto-archive.never"),
            },
            {
                value: "14d",
                text: i18n.tc("settings.channels.auto-archive.day", 14),
            },
            {
                value: "1m",
                text: i18n.tc("settings.channels.auto-archive.month", 1),
            },
            {
                value: "2m",
                text: i18n.tc("settings.channels.auto-archive.month", 2),
            },
            {
                value: "3m",
                text: i18n.tc("settings.channels.auto-archive.month", 3),
            },
            {
                value: "6m",
                text: i18n.tc("settings.channels.auto-archive.month", 6),
            },
            {
                value: "12m",
                text: i18n.tc("settings.channels.auto-archive.month", 12),
            },
        ];

        const attachmentData = ref({
            outOfOfficeWeekendAsset: "",
            outOfOfficeAsset: "",
            autoReplyAsset: "",
            customStatementAsset: "",
        });
        const attachmentsAreUploading = ref({
            outOfOfficeWeekendAsset: false,
            outOfOfficeAsset: false,
            autoReplyAsset: false,
            customStatementAsset: false,
        });

        const setAttachment = (file, settingName) => {
            attachmentsAreUploading.value[settingName] = true;
            uploadFile(
                file,
                resolveFilesizeLimit(props.channelData.provider, props.channelData.platform, file.type),
                { platform: props.channelData.platform, provider: props.channelData.provider },
                `channels/${props.channelData.id}/auto-replies/`
            )
                .then((uploadedFile) => {
                    axios.post("assets", uploadedFile).then((asset) => {
                        getSettingByName(settingName).value = asset.data.id;
                        attachmentData.value[settingName] = asset.data.originalName;
                        toast({
                            component: ToastificationContent,
                            props: {
                                title: i18n.t("settings.channels.files.uploaded.success"),
                                text: i18n.t("settings.channels.files.uploaded.success-text"),
                                icon: "check",
                                variant: "success",
                            },
                        });
                    });
                })
                .catch((error) => {
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: i18n.t("settings.channels.files.uploaded.failure"),
                            text:
                                typeof error === "string"
                                    ? error
                                    : i18n.t("settings.channels.files.uploaded.failure-text"),
                            icon: "times",
                            variant: "danger",
                        },
                    });
                })
                .finally(() => (attachmentsAreUploading.value[settingName] = false));
        };

        const removeAttachment = (settingName) => {
            getSettingByName(settingName).value = "";
            attachmentData.value[settingName] = "";
        };

        Object.keys(attachmentData.value).forEach((key) => {
            const assetId = getSettingByName(key).value;
            if (assetId) {
                // This asset setting already has a value.
                // We'll fetch the asset from our db and display the filename to the user.
                axios.get(`assets/${assetId}`).then((asset) => (attachmentData.value[key] = asset.data.originalName));
            }
        });

        return {
            attachmentData,
            attachmentsAreUploading,
            customStatementFrequencies,
            getSettingByName,
            setAttachment,
            removeAttachment,
            PlatformType,
        };
    },
    data() {
        return {
            selectingEmojiFor: "autoReplyMessage",
        };
    },
    methods: {
        addVariable(variable, inputName) {
            const setting = this.getSettingByName(inputName);
            setting.value = addDataToInput(inputName, setting.value || "", variable);
        },
        selectEmoji(emoji, settingName) {
            const setting = this.getSettingByName(settingName);
            setting.value = addDataToInput(settingName, setting.value || "", emoji.data);
        },
    },
};
</script>
<style lang="scss">
@import "~@/assets/scss/vEmojiPicker.scss";
</style>
